import React from 'react'
import './fileitem.css'

const FileItem = ({ file, deleteFile }) => {
    return (
        <div className="file_list">
            <li className='list-name' key={file.name}>
                <i className="uil uil-image"></i>
                <p>{file.name}</p>
                <div className="actions">
                    <i className="uil uil-trash-alt" onClick={() => deleteFile(file.name)}></i>
                </div>
            </li>
        </div>
    )
}

export default FileItem